import React from 'react';

import { MapVolumeInfo } from './MapVolumeInfo';
import { MapIncomePriceInfo } from './MapIncomePriceInfo';
import { MapDistanceInfo } from './MapDistanceInfo';
import { MapOrdersInfo } from './MapOrdersInfo';
import { canViewTransportPrices } from '../../helpers/permissions';

export const MapStatsOverlay = ({
  confirmedVolumeM3,
  totalVolumeM3,
  car,
  confirmedIncomePrice,
  totalIncomePrice,
  isNotPricedPackages,
  orderConfirmedIncomePrice,
  orderTotalIncomePrice,
  exchangeConfirmedIncomePrice,
  exchangeTotalIncomePrice,
  distance,
  routeDistance,
  routeDuration,
  mapOrderCount,
  mapOrderVolumeM3,
  hasReturnPicking = false,
}) => (
  <div className="route-map__overlay">
    {mapOrderCount !== undefined && (
      <MapOrdersInfo
        orderCount={mapOrderCount}
        volumeM3={mapOrderVolumeM3}
      />
    )}
    <MapVolumeInfo
      totalVolumeM3={totalVolumeM3}
      confirmedVolumeM3={confirmedVolumeM3}
      car={car}
    />
    {canViewTransportPrices() && !hasReturnPicking && (
      <MapIncomePriceInfo
        confirmedIncomePrice={confirmedIncomePrice}
        totalIncomePrice={totalIncomePrice}
        isNotPricedPackages={isNotPricedPackages}
        orderConfirmedIncomePrice={orderConfirmedIncomePrice}
        orderTotalIncomePrice={orderTotalIncomePrice}
        exchangeConfirmedIncomePrice={exchangeConfirmedIncomePrice}
        exchangeTotalIncomePrice={exchangeTotalIncomePrice}
      />
    )}
    <MapDistanceInfo
      distance={distance}
      routeDistance={routeDistance}
      routeDuration={routeDuration}
    />
  </div>
);
